<template>
  <div class="binding-iphone" v-title data-title="绑定手机号">
    <!-- 手机号 -->
    <div class="number">
      <van-field v-model="phone" placeholder="请输入手机号"/>
    </div>
    <!-- 验证码 -->
    <div class="verify">
      <van-cell-group>
        <van-field v-model="verification_code" center clearable placeholder="请输入短信验证码">
          <van-button slot="button" size="small" type="primary" :disabled="isbtn" color="#EF8201" @click="btns">{{btnTitle}}</van-button>
        </van-field>
      </van-cell-group>
    </div>
    <!-- 绑定按钮 -->
    <div class="register_btn">
      绑定手机号
    </div>
  </div>
</template>

<script>

import Vue from 'vue';
import { Field, Button, Cell, CellGroup, Toast} from 'vant';
Vue.use(Field);
Vue.use(Button);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Toast);

export default {
  data(){
    return{
      phone : "",
      verification_code : "",
      btnTitle : "获取验证码",
      isbtn : false,
    }
  },
  methods:{
    btns(){
      if (!this.phone) {
        // this.errors = {
        //   phone:"手机号码不能为空"
        // }
        Toast('手机号码不能为空');
        // return false
      } else if (!/^1[345678]\d{9}$/.test(this.phone)) {
        // this.errors = {
        //   phone:"请输入正确是手机号"
        // }
        Toast('请输入正确的手机号');
      }else{
        this.$axios.post("http://members.kfm666666.net/api/register/verification_code/wx_send/?username=" + this.phone).then((res => {
          console.log(res)
          Toast(res.data.msg)
        }))
        //倒计时
        let time = 60;
        let timer = setInterval(() => {
          if(time == 0) {
            clearInterval(timer);
            this.btnTitle = "获取验证码";
            this.isbtn = false;
          } else {
            this.isbtn = true;
            this.btnTitle = time + '秒后重试';
            time--
          }
        },1000)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .binding-iphone{
    width: 100%;
    .number {
      margin: 0 5.33% 0 5.33%;
      border-bottom: 1px #e6e6e6 solid;
      margin-top: 0.53rem;
      ::-webkit-input-placeholder {
        color: #cccccc;
        font-size: 0.24rem;
        font-family: PingFang-SC-Regular;
      }
      /deep/.van-field{

      }
    }
    .verify {
      margin: 0 5.33% 0 5.33%;
      border-bottom: 1px #e6e6e6 solid;
      margin-top: 0.53rem;
      ::-webkit-input-placeholder {
        color: #cccccc;
        font-size: 0.24rem;
        font-family: PingFang-SC-Regular;
      }
      .van-button--primary {
        background-color: #ffffff;
        color: #999999;
        font-size: 0.26rem;
        border: none;
      }
    }
    // 绑定按钮
    .register_btn{
      width: 70%;
      margin: 0 auto;
      height: .8rem;
      margin-top: .7rem;
      background: #EF8201;
      text-align: center;
      line-height: .8rem;
      border-radius: .5rem;
      font-size: .28rem;
      color: #ffffff;
      font-weight: bold;
    }
  }
</style>